import { Injectable } from "@angular/core";
import { ApiEvsService } from "app/common/services/ApiEvs.service";

@Injectable()
export class OrderService {
  constructor(private http: ApiEvsService) {}

  public getListOrders(request: any) {
    return this.http.get("/orders", request);
  }
  public downloadExcel(request: any) {
    return this.http.getExcel("/orders/excel", request);
  }
  public getOrderbyId(id: any) {
    return this.http.get("/orders/" + id);
  }
  public createOrder(body: any) {
    return this.http.post("/orders", body);
  }
  public updateOrder(id: any, body: any) {
    return this.http.post("/orders/" + id, body);
  }
  public cancelOrder(id: any) {
    return this.http.post("/orders/" + id + "/cancel");
  }
}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/qrcode/order/order/order.service.ts